import React, { useEffect, useState } from "react";
import EventImage1 from "../../../../assets/image/image-event-01.webp";
import EventImage2 from "../../../../assets/image/image-event-02.webp";
import EventImage3 from "../../../../assets/image/image-event-03.webp";
import Image from "../../../elements/Image";
import { classNames } from "../../../../helpers/classNames";
import useFetch from "../../../../hooks/useFetch";
import { getBlogList } from "../../../../services/BlogService";
import dayjs from "dayjs";
import AnnouncementItem from "../Common/AnnouncementItem";

const ImportantDatesSection = () => {
  const [event, setActiveEvent] = useState();
  const {
    data: events,
    error,
    isLoading,
    updateData,
    isFetching,
    refetch,
  } = useFetch({
    dependencies: ["font-event"],
    fetchFunction: async () => {
      const res = await getBlogList({
        type: "event",
        limit: 3,
        sortQuery: "-createdAt",
        upcomingEvent: true,
        status: 1,
      });
      if (res?.docs?.status === 200) {
        return (res?.docs?.data || [])?.map((item) => ({
          ...item,
          _id: item?._id,
          date: {
            day: dayjs(item?.publishDate)?.format("DD"),
            month: dayjs(item?.publishDate)?.format("MMMM"),
          },
          image: item?.image?.url,
          link: `/updates/${item?.slug || item?._id}`,
        }));
      } else {
        return [];
      }
    },
  });

  useEffect(() => {
    if (
      Array.isArray(events) &&
      events.length > 0 &&
      !events.some((item) => item?._id === event?._id)
    ) {
      setActiveEvent(events[0]);
    }
  }, [events, event]);

  if (events && Array.isArray(events) && events?.length === 0) {
    return <></>;
  }
  return (
    <section className="relative flex w-full py-16 sm:py-24 bg-white">
      <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
        <div className="space-y-10 sm:space-y-16">
          <h2 className="text-3xl sm:text-4xl xls:text-[42px] font-bold text-center">
            Important Dates
          </h2>
          <div>
            {(events || []).map((item, index) => (
              <AnnouncementItem key={index} index={index} data={item} />
            ))}
          </div>

          {/* <div className="relative w-full lg:flex">
            <div className="flex flex-col">
              {(events || []).map((item, index) => (
                <button
                  key={index}
                  className={classNames(
                    "w-full lg:flex-grow text-left flex items-center transition-all duration-200",
                    event?._id === item?._id ? "bg-chestnut-rose text-white" : "bg-shades-03 text-gable-green"
                  )}
                  onClick={() => setActiveEvent(item)}
                >
                  <div className="lg:h-full w-28 lg:w-auto lg:aspect-square flex-shrink-0 flex flex-col items-center justify-center py-4">
                    <div className="text-4xl sm:text-5xl xls:text-7xl xl:text-[86px] leading-none font-bold font-CanelaDeck">{item?.date}</div>
                    <div className="text-sm sm:text-base xls:text-xl xl:text-2xl font-semibold font-CanelaDeck">{item?.month}</div>
                  </div>
                  <div className="lg:h-full flex-shrink flex-grow flex flex-col justify-center px-6 xls:px-10 py-4 gap-2 xls:gap-4 border-l border-white">
                    <h2 className="text-sm sm:text-lg xls:text-xl xl:text-2xl font-bold line-clamp-2">{item?.title}</h2>
                    <div className="text-xs sm:text-sm xls:text-base xl:text-lg font-Gotham xls:font-medium line-clamp-2" dangerouslySetInnerHTML={{ __html: item?.description }} />
                  </div>
                </button>
              ))}
            </div>
            <div className="w-full lg:w-[45%] flex flex-shrink-0">
              <div className="w-full aspect-[4/3] sm:aspect-[2/1] lg:aspect-[11/10] overflow-hidden">
                {event?.image && <Image src={event?.image} alt={event?.title} effect="blur" classes="object-cover" />}
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default ImportantDatesSection;
